<!--
 * @Date: 2024-04-10 16:36:50
 * @LastEditTime: 2024-05-20 14:56:33
-->
<template>
  <Header
    :leftArrow="true"
    :leftText="''"
    @leftClick="onClickLeft"
    :rightIcons="false"
  />
  <section
    style="
      position: relative;
      background-color: rgb(244, 251, 255);
      padding-top: 3rem;
      margin: 0 auto;
      width: 90% !important;
    "
  >
    <Schedule :events="events" :schedules="schedules" />
  </section>
</template>

<script setup>
import Schedule from "@/components/Schedule.vue";
import Header from "@/components/Header.vue";
import { useRouter } from "vue-router";
import { GetScheduls } from "@/services/room";
import { ref, computed, onMounted } from "vue";
const router = useRouter();
const onClickLeft = () => {
  router.push("/dashBoard");
};

const events = ref();
const schedules = ref();
const userInfo = computed(() => {
  return JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY)) || {};
});

const getEvents = async () => {
  try {
    const {
      data: { data },
    } = await GetScheduls({
      login_account_id: userInfo.value.login_account_id,
    });
    events.value = data.map((v) => ({
      id: v.roomyotei_id,
      title: v.yotei_name,
      start: v.start_time,
      end: v.end_time,
      color:
        userInfo.value.login_account_id === v.created_by
          ? "rgb(199,228,252)"
          : "rgb(255,234,204)",
      editable: false,
      overlap: true,
    }));
    schedules.value = data;
  } catch (error) {
    console.error(error);
  }
};
onMounted(async () => {
  try {
    await getEvents();
  } catch (error) {
    console.error(error);
  }
});
</script>
